module.exports = __webpack_public_path__ + "static/media/cargas-gris.2f4c5899.svg";